<template>
  <v-dialog
      v-model="dialog"
      width="650px"
  >
    <v-card>
      <v-card-text>
      <!-- <v-container
        id="regular-tables"
        fluid
        tag="section"
      > -->

        <v-card-title class="pa-2">
          Crear comentario
        </v-card-title>

        <v-form
          ref="formNewComentario"
          lazy-validation
          @submit.prevent="save()"
        >
          <div>
            <v-textarea
              v-model="comentario"
              class="px-2 py-1"
              :rules="[v => !!v || 'El Comentario es obligatorio']"
              flat
              label="Comentario"
              hide-details
              outlined
              required
            />
          </div>

          <v-card-actions class="pa-2">
            <v-btn
              outlined
              @click="close"
            >
              Cancelar
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
              Agregar
            </v-btn>
          </v-card-actions>
        </v-form>
        <v-divider></v-divider>
        <br>
        Todos los comentarios
        <v-divider></v-divider>

        <v-data-table
          :headers="headers"
          :items="comentarios"
          item-key="name"
          class="elevation-1"
          :search="search"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import moment from 'moment'
  moment.locale('es')
  export default {
    components: {
    },
    data () {
      return {
        dialog: false,
        loading: false,
        headers: [
          { text: 'Email del usuario', value: 'email_user' },
          { text: 'Comentario', value: 'comentario' },
          // { text: 'Convocatoria', value: 'convocatoria' },
          { text: 'Fecha Y Hora', value: 'created_at' },
        ],
        comentarios: [],
        search: '',
        clienteId: undefined,
        convocatoria: undefined,
        comentario: '',

      }
    },
    computed: {

    },
    mounted () {
      // this.existeEntidadId()
    },
    methods: {
      open (cliente) {
        this.dialog = true
        this.clienteId = cliente.id
        this.getComentarios()
        this.search = ''
      },
      close () {
        this.dialog = false
        this.$refs.formNewComentario.reset()
      },
      existeEntidadId () {
        if (!this.clienteId) {
          this.$router.push({ name: 'Entidades Tecnicas' })
        } else {
          this.getComentarios()
        }
      },
      async getComentarios () {
        this.comentarios = []

        const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/comentario/' + this.clienteId)
        const comentarios = await response.json()
          comentarios.data.forEach(comentario => {
            comentario.created_at = moment(comentario.created_at).format('L') + ' ' + moment(comentario.created_at).format('LT')
          })
        this.comentarios = comentarios.data
      },
      async save () {
        if (this.$refs.formNewComentario.validate()) {
          this.loading = true

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/distribuidores/comentario', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + JSON.parse(localStorage.userAuth).token,
            },
            body: JSON.stringify({
              comentario: this.comentario,
              email_user: JSON.parse(localStorage.userAuth).email,
              cliente_id: this.clienteId,
            }),
          })
          const comentarios = await response.json()
          if (comentarios) {
            this.loading = false
            this.$refs.formNewComentario.reset()
            this.getComentarios()
          }
        } else {
          this.loading = false
        }
      },
    },
  }
</script>

<style>

</style>
